var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"text-align":"center","white-space":"pre-line","font-size":"20px","font-weight":"bold"}},[_vm._v("\n    AGROCOLOR Registration Number "+_vm._s(_vm.codigo_interno)+"\n    GGN: "+_vm._s(_vm.ggn)+" \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }